export default __webpack_public_path__ + "static/media/roadmap-head-shark-4.f626e5d7.png";